import BDS1 from "./area/BDS1";
import { IconButton, Tabs } from 'components/common';
import BDS2 from "./area/BDS2";
import BDS3 from "./area/BDS3";
import React from 'react';
import PropTypes from 'prop-types';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';
const BDS = ({
  data,
  area,
  editArea,
  deleteArea,
  openWallData,
  newOpenWall,
  editOpenWall,
  deleteOpenWall,
  roofExtensionData,
  newRoofExtension,
  editRoofExtension,
  deleteRoofExtension,
  canopyData,
  newCanopy,
  editCanopy,
  deleteCanopy,
  fasciaData,
  newFascia,
  editFascia,
  deleteFascia,
  frameOpeningData,
  newFrameOpening,
  editFrameOpening,
  deleteFrameOpening,
  mezzanineData,
  newMezzanine,
  editMezzanine,
  deleteMezzanine,
  craneInformationData,
  newCraneInformation,
  editCraneInformation,
  deleteCraneInformation
}) => {
  const newData = {...data, area}

  return (
    <>
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-2 tw-text-sm">
        <div className="tw-text-primary-600 tw-font-semibold">Area {area?.id}</div>
        <div className="tw-flex tw-items-center tw-gap-1">
          <IconButton
            size="sm"
            icon={<FaEdit size={12} />}
            onClick={editArea}
          >
            <span className="tw-hidden xl:tw-inline-block">Edit Area</span>
          </IconButton>

          <IconButton
            size="sm"
            icon={<FaTrashAlt size={12} />}
            onClick={deleteArea}
          >
            <span className="tw-hidden xl:tw-inline-block">Delete Area</span>
          </IconButton>
        </div>
      </div>

      <Tabs
        variant="underline"
        lazyMount
        navClassName="tw-bg-white tw-px-2 tw-pt-1 tw-border tw-border-solid tw-border-slate-200 tw-rounded-t"
        contentClassName="tw-bg-slate-50 tw-text-sm tw-border tw-border-t-0 tw-border-solid tw-border-slate-200 tw-rounded-b"
        tabs={[
          {
            label: 'BDS1',
            content: (
              <BDS1
                data={newData}
                openWallData={openWallData}
                newOpenWall={newOpenWall}
                editOpenWall={editOpenWall}
                deleteOpenWall={deleteOpenWall}
              />
            )
          },
          {
            label: 'BDS2',
            content: (
              <BDS2
                data={newData}
                roofExtensionData={roofExtensionData}
                newRoofExtension={newRoofExtension}
                editRoofExtension={editRoofExtension}
                deleteRoofExtension={deleteRoofExtension}
                canopyData={canopyData}
                newCanopy={newCanopy}
                editCanopy={editCanopy}
                deleteCanopy={deleteCanopy}
                fasciaData={fasciaData}
                newFascia={newFascia}
                editFascia={editFascia}
                deleteFascia={deleteFascia}
                frameOpeningData={frameOpeningData}
                newFrameOpening={newFrameOpening}
                editFrameOpening={editFrameOpening}
                deleteFrameOpening={deleteFrameOpening}
                mezzanineData={mezzanineData}
                newMezzanine={newMezzanine}
                editMezzanine={editMezzanine}
                deleteMezzanine={deleteMezzanine}
                craneInformationData={craneInformationData}
                newCraneInformation={newCraneInformation}
                editCraneInformation={editCraneInformation}
                deleteCraneInformation={deleteCraneInformation}
              />
            )
          },
          {
            label: 'BDS3',
            content: <BDS3 data={newData} />
          }
        ]}
      />
    </>
  )
};

BDS.propTypes = {
  data: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  editArea: PropTypes.func.isRequired,
  deleteArea: PropTypes.func.isRequired,
  openWallData: PropTypes.func.isRequired,
  newOpenWall: PropTypes.func.isRequired,
  editOpenWall: PropTypes.func.isRequired,
  deleteOpenWall: PropTypes.func.isRequired,
  roofExtensionData: PropTypes.func.isRequired,
  newRoofExtension: PropTypes.func.isRequired,
  editRoofExtension: PropTypes.func.isRequired,
  deleteRoofExtension: PropTypes.func.isRequired,
  canopyData: PropTypes.func.isRequired,
  newCanopy: PropTypes.func.isRequired,
  editCanopy: PropTypes.func.isRequired,
  deleteCanopy: PropTypes.func.isRequired,
  fasciaData: PropTypes.func.isRequired,
  newFascia: PropTypes.func.isRequired,
  editFascia: PropTypes.func.isRequired,
  deleteFascia: PropTypes.func.isRequired,
  frameOpeningData: PropTypes.func.isRequired,
  newFrameOpening: PropTypes.func.isRequired,
  editFrameOpening: PropTypes.func.isRequired,
  deleteFrameOpening: PropTypes.func.isRequired,
  mezzanineData: PropTypes.func.isRequired,
  newMezzanine: PropTypes.func.isRequired,
  editMezzanine: PropTypes.func.isRequired,
  deleteMezzanine: PropTypes.func.isRequired,
  craneInformationData: PropTypes.func.isRequired,
  newCraneInformation: PropTypes.func.isRequired,
  editCraneInformation: PropTypes.func.isRequired,
  deleteCraneInformation: PropTypes.func.isRequired
};

export default BDS;
